import classNames from "classnames";
import "./FormField.styles.css";
// import "./FormFieldCheckbox.scss";
import { ErrorMessage, Field } from "formik";
import { useEffect } from "react";

interface Props {
  name: string;
  label?: string;
  errors?: Array<any>;
  required?: boolean;
  values?: Array<any>;
  setFieldValue?: Function;
  placeholder?: string;
  value?: any;
}

const FormFieldCheckbox = ({name, label, value, setFieldValue} : Props) => {
  
 useEffect(() => {
    let elements = document.getElementsByName(name);
    for (let i = 0; i < elements.length; i++) {
      if(setFieldValue) setFieldValue(name, value);
      elements[i].setAttribute("checked", value.toString());
    }
 }, []);

  return (
    <div className={"d-block w-100 form-field col-12 mt-0 p-0"}>
      <div className={classNames("w-100")}
      >
        <div className="w-100 form-checkbox">
          <label>
            <Field 
              id={name}
              name={name} 
              //value={value} 
              type="checkbox"
              >
              {({ field } : any) => (
                <label>
                  <input
                    name={name}
                    id={name}
                    type="checkbox"
                    {...field}
                    // checked={field.value}
                    // value={value}
                    onClick={(e) => {  
                      let newTarget = e.target as HTMLInputElement;
                      const { value, checked, attributes } = newTarget;
                      let newValue = attributes.getNamedItem("name")?.value;
                      console.log("ATTRIBUTES: ", newValue);
                      console.log(`${newValue} is ${checked}`); 
                      newTarget.setAttribute("checked", checked.toString());
                      if(setFieldValue) setFieldValue(name, checked);
                    }}
                  />
                  
                </label>
              )}
            </Field>
            <label className="pl-2" htmlFor={name}>{label}</label>
          </label>
        </div>
        <div className="span field-error"> 
          <ErrorMessage name={name}/>
        </div>
      </div>
    </div>
  )
}

export default FormFieldCheckbox;